import type { FreemiumIntentId } from '@shared';

/**
 * Direct "tool" destination for an intent — the page/modal the advisor should
 * land on to actually do that task. Returns null for self-funding (which starts
 * the guided-planning flow) and the open-ended consult intents, which their
 * callers handle separately.
 *
 * Modal-based intents route back to funding-sources with an ?fxAction param that
 * use-funding-sources-slide reads to auto-open the matching sheet.
 */
export function freemiumIntentToolPath(
  clientId: string,
  intent: FreemiumIntentId | null,
): string | null {
  const base = `/clients/${clientId}/onboarding`;

  switch (intent) {
    case 'analyze-policy':
      return `${base}/funding-sources?fxAction=analyze-policy`;
    case 'explore-quotes':
      return `${base}/shop-insurance`;
    case 'rate-action':
      return `/clients/${clientId}/rate-action-letter`;
    case 'ccrc-offer':
      return `${base}/funding-sources?fxAction=ccrc`;
    default:
      return null;
  }
}
